export const light = {
  body: '#f5f5f5',
  text: '#111827',
  bodyRgba: '245,245,245',
  textRgba: '17,24,39',

  grey: '#e5e7eb',

  accent: '#0ea5e9',
  accentSoft: 'rgba(14, 165, 233, 0.35)',

  fontxs: '0.75em',
  fontsm: '0.875em',
  fontmd: '1em', // 1em = 16px
  fontlg: '1.25em',
  fontxl: '2em',
  fontxxl: '3em',
  fontxxxl: '4em',

  fontButton: '0.875em',

  navHeight: '5rem',
};

export const blueRed = {
  body: '#020617',
  text: '#e5e7eb',
  textRgba: '229,231,235',
  bodyRgba: '2,6,23',

  grey: '#64748b',

  accent: '#f97316',
  accentSoft: 'rgba(249, 115, 22, 0.45)',

  fontxs: '0.75em',
  fontsm: '0.875em',
  fontmd: '1em', // 1em = 16px
  fontlg: '1.25em',
  fontxl: '2em',
  fontxxl: '3em',
  fontxxxl: '4em',

  fontButton: '0.875em',

  navHeight: '5rem',
};

export const themes = {
  dark,
  light,
  blueRed,
};

export const dark = {
  body: '#020617',
  text: '#f9fafb',
  textRgba: '249,250,251',
  bodyRgba: '2,6,23',

  grey: '#4b5563',

  accent: '#22c55e',
  accentSoft: 'rgba(34, 197, 94, 0.4)',

  fontxs: '0.75em',
  fontsm: '0.875em',
  fontmd: '1em', // 1em = 16px
  fontlg: '1.25em',
  fontxl: '2em',
  fontxxl: '3em',
  fontxxxl: '4em',

  fontButton: '0.875em',

  navHeight: '5rem',
};
